import style from "./style.module.scss";

function Item({ id, author, text, image }) {
    return <div className={style.Item} id={id}>
        <div className={style.sub}>
            <div className={style.image} style={{ backgroundImage: `url("${image}")` }} />
            <div className={style.content}>
                <img className={style.quote} src="Images/infopages/testimony/quote.svg" alt="quote" />
                <div className={style.text}>{text}</div>
                {
                    author.map((autTxt, i) => {
                        const ret = [<div className={style.author} style={(i !== 0) ? { marginTop: "0px" } : {}}> {autTxt}</div>];
                        return ret;
                    })
                }
            </div>
        </div>
    </div >
}

export default Item;